module.exports = __webpack_public_path__ + "66dd448f2f59e799d683c68ee971604c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/witch-hat-s.png
// module id = 2962
// module chunks = 0